import { render } from "./App.vue?vue&type=template&id=35e42d80"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35e42d80&lang=css"

import exportComponent from "C:\\workspace\\bxoa_html5_share\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__